<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js' 
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
			};
		},
		props: {
			showpz: { 
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {
		},
		methods: {
			inputblur(e){
				this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}){
				if(columnIndex===0){
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 4
						};
					}else if (rowIndex === 9) {
						return {
							rowspan: 1,
							colspan: 4
						};
					}else if (rowIndex === 22) {
						return {
							rowspan: 1,
							colspan: 4
						};
					}else if (rowIndex === 40) {
						return {
							rowspan: 1,
							colspan: 4
						};
					}else if (rowIndex === 47) {
						return {
							rowspan: 1,
							colspan: 4
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex===1){
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 9) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 22) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 40) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 47) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex===2){
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 9) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 22) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 40) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 47) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}else if(columnIndex===3){
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 9) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 22) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 40) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if (rowIndex === 47) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}else{
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				}
			}
		},
		
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
